import React from 'react';
import PropTypes from 'prop-types';
import Cell from './Cell';
import cx from 'classnames';

function Row({ data, columns, selected, selectRow, rowIndex, onRowClick }) {

    const className = cx({ ['selected-row']: selected });
    
    return (
        <tr
            onClick={(event) => {
                selectRow();
                if(onRowClick) 
                    onRowClick(data, rowIndex, event);
            }}
            style={{ cursor: onRowClick ? 'pointer' : 'initial' }}
            className={className}
        >
            {columns.map((column, index) => (
                <Cell
                    key={`Cell-${rowIndex}-${index}`}
                    data={data}
                    {...column}
                />
            ))}
        </tr>
    );
}

Row.propTypes = {
    data: PropTypes.object,
    columns: PropTypes.array,
    rowIndex: PropTypes.number,
    selected: PropTypes.bool,
    selectRow: PropTypes.func,
    onRowClick: PropTypes.func
};

export default React.memo(Row);
